// import external dependencies
import 'jquery';

// Import everything from autoload



import Splide from '@splidejs/splide';

new Splide( '#splide-testimonials-portfolio', {
	perPage: 1,
  arrows: false,
  pagination: true,
  autoHeight: false,

  classes: {
		// Add classes for arrows.
		// arrows: 'splide__arrows your-class-arrows',
		// arrow : 'splide__arrow your-class-arrow',
		// prev  : 'splide__arrow--prev your-class-prev',
		// next  : 'splide__arrow--next your-class-next',
		
		// Add classes for pagination.
		pagination: 'splide__pagination', // container
		page      : 'splide__pagination__page w-4 h-4 block border rounded-full', // each button
	},



} ).mount();

const splideGrid = new Splide( '#splide-portfolio-grid', {
	perPage: 1,
  arrows: false,
  pagination: true,
  autoHeight: false,

  classes: {
		// Add classes for arrows.
		// arrows: 'splide__arrows your-class-arrows',
		// arrow : 'splide__arrow your-class-arrow',
		// prev  : 'splide__arrow--prev your-class-prev',
		// next  : 'splide__arrow--next your-class-next',
		
		// Add classes for pagination.
		pagination: 'splide__pagination slide-portfolio-grid', // container
		page      : 'splide__pagination__page w-4 h-4 block border rounded-full', // each button
	},



} ).mount();


//console.log( splideGrid.length );

if ( splideGrid.length >= 1 ) {

 const getPagination = document.querySelector('.slide-portfolio-grid > li');

 getPagination.style.display = 'none'; 

	//console.log( 'True' );
}

